import React from 'react';

type Accent = 'green' | 'gold' | 'ruby' | 'ink';

interface Props {
  accent: Accent;
  label: string;
  value: string | number;
  sublabel?: string;
  className?: string;
}

const ACCENT_BORDER: Record<Accent, string> = {
  green: 'border-l-green-700',
  gold: 'border-l-gold-500',
  ruby: 'border-l-ruby-500',
  ink: 'border-l-ink-700',
};

const ACCENT_VALUE: Record<Accent, string> = {
  green: 'text-green-900',
  gold: 'text-gold-600',
  ruby: 'text-ruby-700',
  ink: 'text-ink-900',
};

export function StatCard({ accent, label, value, sublabel, className = '' }: Props) {
  return (
    <div
      className={[
        'bg-white rounded-xl border border-ink-300 border-l-4',
        ACCENT_BORDER[accent],
        'px-4 py-3 flex flex-col gap-0.5 shadow-xs',
        className,
      ].join(' ')}
    >
      <span className="bt-eyebrow text-ink-500">{label}</span>
      <span
        className={[
          'font-display font-extrabold tabular-nums leading-none mt-1',
          'text-[clamp(24px,4vw,32px)]',
          ACCENT_VALUE[accent],
        ].join(' ')}
      >
        {value}
      </span>
      {sublabel && <span className="text-caption text-ink-500 mt-1">{sublabel}</span>}
    </div>
  );
}
